import { useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
  VStack,
  RadioGroup,
  Radio,
  Stack,
  Text,
} from "@chakra-ui/react";

import client from "../../../../../helpers/Client";
import TeamSelect from "../../../../../components/select/TeamSelect";
import UserPicker from "../../../../../components/select/UserPicker";
import urlToId from "../../../../../helpers/UrlToId";
import SaveButton from "../../../../../components/buttons/SaveButton";

export default function AssingTaskModal({
  task,
  resellerID,
  ticketRevalidator,
  assignTaskModalState,
}) {
  const preSelectedTeamURL = task?.assigned_to?.url;
  const preSelectedUserURL = task?.assigned_user?.url;
  const [assignmentType, setAssignmentType] = useState(
    preSelectedTeamURL ? "team" : preSelectedUserURL ? "user" : "team"
  );
  const [selectedTeamURL, setSelectedTeamURL] = useState(preSelectedTeamURL);
  const [selectedUserURL, setSelectedUserURL] = useState(preSelectedUserURL);
  const toast = useToast();

  const handleAssign = async () => {
    const body = {};
    if (assignmentType === "team") {
      body.assigned_to = selectedTeamURL;
      body.assigned_user = null;
    } else {
      body.assigned_user = selectedUserURL || null;
      body.assigned_to = null;
    }

    client
      .post(`/tasks/${urlToId(task.url)}/assign/`, body)
      .then((response) => {
        if (!response.data.success) {
          return alert(response.errors.assigned_to?.join("\r\n") || response.errors.assigned_user?.join("\r\n"));
        }
        ticketRevalidator.revalidate();
        assignTaskModalState.onClose();
        toast({
          title: assignmentType === "team" ? "Alt görev takıma atandı" : "Alt görev kullanıcıya atandı",
          status: "success",
        });
      })
      .catch((error) => {
        Object.values(error.response.data).forEach((value) => {
          toast({
            title: "İşlem gerçekleştirilemiyor: " + value,
            status: "error",
          });
        });
      });
  };
  return (
    <Modal
      isOpen={assignTaskModalState.isOpen}
      onClose={assignTaskModalState.onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Görev Ata</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <RadioGroup value={assignmentType} onChange={setAssignmentType}>
              <Text fontWeight="semibold" mb={2}>Atama Türü:</Text>
              <Stack direction="row">
                <Radio value="team">Takıma Ata</Radio>
                <Radio value="user">Kullanıcıya Ata</Radio>
              </Stack>
            </RadioGroup>

            {assignmentType === "team" ? (
              <TeamSelect
                {...{ resellerID, selectedTeamURL, setSelectedTeamURL }}
              />
            ) : (
              <UserPicker
                resellerID={resellerID}
                value={selectedUserURL || ""}
                onChange={setSelectedUserURL}
              />
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={assignTaskModalState.onClose}
          >
            Vazgeç
          </Button>
          <SaveButton onClick={handleAssign}>Kaydet</SaveButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
